import React from 'react'
import { DefaultLayout } from '../../layouts'
import { SimplePageHeader } from '../../components'
import { MainContent } from './components'
import { useInternationalization } from '../../features/i18n'

const Contact = () => {
  const { translate } = useInternationalization()

  return (
    <DefaultLayout>
      <SimplePageHeader
        title={translate('FOOTER', 'footer_contact')}
        largePadding
      />
      <MainContent />
    </DefaultLayout>
  )
}

export { Contact }
